import { useMemo } from 'react'
import { CircularProgress, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { makeStyles } from '@material-ui/core/styles'
import MyTable from '../MyTable/MyTable'
import SortItems from '../MyTable/SortItems'
import { func, string, number, bool, shape, arrayOf } from 'prop-types'
import { useOutletContext } from 'react-router-dom'
import { connect } from 'react-redux'

function withOutletContext(WrappedComponent) {
  return function WrapperComponent(props) {
    const outletContext = useOutletContext()
    return <WrappedComponent {...props} outletContext={outletContext} />
  }
}

const styles = makeStyles((theme) => ({
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
  tableUnset: {
    whiteSpace: 'unset',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
  leftDiv: {
    fontSize: 16,
    padding: '1px',
    margin: '1px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  iconDelete: {
    fontSize: 24,
    padding: '1px',
    margin: '1px',
    textAlign: 'right',
    width: '100%',
  },
  iconStyle: {
    width: '36px',
    height: '36px',
  },
}))

const MessageTemplateItems = (props) => {
  const classes = styles(props)
  const {
    callbackFromParentUpdateData,
    callbackFromParentDeleteData,
    dataFromParent,
    fetchingState,
    pageFromParent,
    pageSizeFromParent,
  } = props

  var tempData = []

  const columns = useMemo(
    () => [
      {
        Header: ' ',
        columns: [
          {
            Header: 'Message Template Name',
            accessor: 'message_title',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
            Cell: (row) => (
              <table>
                <tbody>
                  <tr>
                    <td className={classes.leftDiv}>{row.cell.value}</td>
                    <td className={classes.iconDelete}>
                      <IconButton
                        onClick={() => {
                          callbackFromParentUpdateData(row.cell.row)
                        }}
                        aria-label="Update"
                        className={classes.iconStyle}
                      >
                        <EditIcon className={classes.iconDelete} />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          callbackFromParentDeleteData(
                            row.cell.row.original['pk_id'],
                          )
                        }}
                        aria-label="Delete"
                        className={classes.iconStyle}
                      >
                        <DeleteIcon className={classes.iconDelete} />
                      </IconButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            ),
          },
        ],
      },
    ],
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )

  // pass only array data
  if (dataFromParent !== null) {
    tempData = dataFromParent
  }

  if (fetchingState) {
    return (
      <div className={classes.centerDiv}>
        <CircularProgress className={classes.spinner} thickness={7} />
        <h3>loading...</h3>
      </div>
    )
  } else {
    return (
      <MyTable
        columns={columns}
        data={tempData}
        defaultPageSize={pageSizeFromParent}
        defaultPageIndex={pageFromParent}
        maxPageCount={Math.ceil(tempData.length / 10)} // calculate based on data
        defaultSortColumn={[
          {
            id: 'message_title',
            desc: false,
          },
        ]}
      />
    )
  }
}

const MessageTemplateItemsWithContext = withOutletContext(MessageTemplateItems)
const StyledConnectedMessageTemplateMaintenancePage = connect()(
  MessageTemplateItemsWithContext,
)

export default StyledConnectedMessageTemplateMaintenancePage

MessageTemplateItems.proptype = {
  callbackFromParentUpdateData: func.isRequired,
  callbackFromParentDeleteData: func.isRequired,
  dataFromParent: arrayOf(
    shape({
      message_title: string,
    }),
  ),
  fetchingState: bool,
  pageFromParent: number,
  pageSizeFromParent: number,
}
